"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoritesOn = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const FavoritesOn = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(13.772 1.693)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M48.2,25.2C50.1,15.8,44,6.6,34.6,4.7C28.9,3.5,23,5.3,18.8,9.4C12,2.6,1,2.6-5.8,9.4s-6.8,17.8,0,24.6l0,0\r l24.6,24.6l9-9"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M18.8,61.1c-0.7,0-1.3-0.3-1.8-0.7L-7.5,35.8c-3.8-3.8-5.8-8.8-5.8-14.1c0-5.3,2.1-10.3,5.8-14.1\r c3.8-3.8,8.8-5.8,14.1-5.8c4.5,0,8.8,1.5,12.3,4.3c4.6-3.6,10.5-5,16.3-3.9c5.2,1.1,9.7,4.1,12.6,8.5s4,9.7,2.9,14.9l-4.9-1\r c0.8-3.9,0-7.9-2.2-11.2c-2.2-3.3-5.5-5.6-9.4-6.4c-4.9-1-10,0.5-13.5,4.1c-1,1-2.6,1-3.5,0c-2.8-2.8-6.6-4.4-10.5-4.4\r S-1.2,8.4-4,11.2c-2.8,2.8-4.4,6.6-4.4,10.5s1.5,7.7,4.4,10.5l22.8,22.8l7.2-7.2l3.5,3.5l-9,9C20.1,60.8,19.5,61.1,18.8,61.1z"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M-10.5,25.2C-12.4,15.8-6.3,6.6,3.1,4.7c5.7-1.2,11.6,0.6,15.8,4.7c6.8-6.8,17.8-6.8,24.6,0s6.8,17.8,0,24.6\r L18.8,58.6l-9-9"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M18.8,61.1c-0.6,0-1.3-0.2-1.8-0.7l-9-9l3.5-3.5l7.2,7.2l22.8-22.8c2.8-2.8,4.4-6.6,4.4-10.5\r s-1.5-7.7-4.4-10.5c-2.8-2.8-6.6-4.4-10.5-4.4s-7.7,1.5-10.5,4.4c-1,1-2.6,1-3.5,0C13.5,7.6,8.5,6.1,3.6,7.1\r c-3.9,0.8-7.3,3.1-9.4,6.4c-2.2,3.3-3,7.3-2.2,11.2l-4.9,1c-1.1-5.2,0-10.5,2.9-14.9s7.4-7.5,12.6-8.5C8.3,1,14.3,2.5,18.8,6.1\r c3.5-2.8,7.8-4.3,12.3-4.3c5.3,0,10.3,2.1,14.1,5.8C49,11.4,51,16.4,51,21.7C51,27,49,32,45.2,35.8L20.6,60.4\r C20.1,60.8,19.5,61.1,18.8,61.1z"
        })]
      })]
    })
  });
};
exports.FavoritesOn = FavoritesOn;